export enum PrizeStatusEnum {
  READY = 'READY',
  ARCHIVED = 'ARCHIVED',
  USED='USED'
}
